/* Product Info Tabs JavaScript */

document.addEventListener('DOMContentLoaded', function() {
  // Find all product info tabs containers
  const containers = document.querySelectorAll('.product-info-tabs');
  
  containers.forEach(function(container) {
    // Always initialize read more if buttons exist (server-side decides visibility)
    initReadMore(container);
    
    initTabSwitching(container);
  });
  
  function initReadMore(container) {
    const allExpandableContent = container.querySelectorAll('.product-info-tabs__expandable');
    
    allExpandableContent.forEach(function(contentDiv) {
      const contentId = contentDiv.id;
      if (!contentId) return;
      
      // Get the corresponding button
      const tabId = contentId.replace('expandable-', '');
      const readMoreBtn = container.querySelector('#read-more-btn-' + tabId);
      
      if (!readMoreBtn) return;
      
      const contentWrapper = contentDiv.querySelector('.product-info-tabs__text');
      if (!contentWrapper) return;
      
      // Count total characters (excluding HTML)
      const allText = contentWrapper.textContent || contentWrapper.innerText || '';
      const totalChars = allText.trim().length;
      
      // Only show button and collapse if content is longer than 250 characters
      if (totalChars > 250) {
        // Show the button
        readMoreBtn.style.display = 'inline-flex';
        
        var children = Array.from(contentWrapper.children);
        
        if (children.length === 0) return;
        
        // Check if all content is wrapped in a single div/p
        if (children.length === 1 && (children[0].tagName === 'DIV' || children[0].tagName === 'P')) {
          // Get children from inside the wrapper
          const innerChildren = Array.from(children[0].children);
          if (innerChildren.length > 0) {
            children = innerChildren;
          }
        }
        
        // Find split point - keep adding elements until we reach ~250 characters
        var charsSoFar = 0;
        var splitIndex = 0;
        const CHAR_LIMIT = 250;
        
        for (var i = 0; i < children.length; i++) {
          const childText = children[i].textContent || '';
          const childChars = childText.trim().length;
          
          // If adding this element would exceed limit, stop here
          if (charsSoFar + childChars > CHAR_LIMIT && i > 0) {
            splitIndex = i;
            break;
          }
          
          charsSoFar += childChars;
          splitIndex = i + 1;
        }
        
        // Ensure at least 1 element visible, but not more than needed
        if (splitIndex === 0) splitIndex = 1;
        if (splitIndex > children.length) splitIndex = children.length;
        
        // Hide content after split
        if (splitIndex < children.length) {
          const hiddenSpan = document.createElement('span');
          hiddenSpan.className = 'product-info-tabs__hidden-content';
          
          for (var j = splitIndex; j < children.length; j++) {
            hiddenSpan.appendChild(children[j]);
          }
          
          // Append to the parent where children came from
          const parent = children[0].parentElement;
          parent.appendChild(hiddenSpan);
          
          contentDiv.classList.add('product-info-tabs__expandable--collapsed');
        }
      } else {
        // Hide button if content is 250 characters or less
        readMoreBtn.style.display = 'none';
      }
      
      // Click handler
      readMoreBtn.addEventListener('click', function() {
        const readMoreText = this.querySelector('.product-info-tabs__read-more-text');
        
        if (contentDiv.classList.contains('product-info-tabs__expandable--collapsed')) {
          contentDiv.classList.remove('product-info-tabs__expandable--collapsed');
          contentDiv.classList.add('product-info-tabs__expandable--expanded');
          this.classList.add('product-info-tabs__read-more-btn--expanded');
          if (readMoreText) readMoreText.textContent = 'Read Less';
        } else {
          contentDiv.classList.remove('product-info-tabs__expandable--expanded');
          contentDiv.classList.add('product-info-tabs__expandable--collapsed');
          this.classList.remove('product-info-tabs__read-more-btn--expanded');
          if (readMoreText) readMoreText.textContent = 'Read More';
        }
      });
    });
  }
  
  function initTabSwitching(container) {
    const tabButtons = container.querySelectorAll('.product-info-tabs__button');
    const tabContents = container.querySelectorAll('.product-info-tabs__content');
    const nav = container.querySelector('.product-info-tabs__nav');
    
    // Initialize scroll state
    if (nav) {
      updateScrollState(nav);
      
      // Update on scroll
      nav.addEventListener('scroll', function() {
        updateScrollState(nav);
      });
      
      // Update on window resize
      window.addEventListener('resize', function() {
        updateScrollState(nav);
      });
    }
    
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Prevent multiple clicks during transition
        if (this.classList.contains('product-info-tabs__button--active')) return;
        
        const targetTab = this.getAttribute('data-tab');
        
        tabButtons.forEach(function(btn) {
          btn.classList.remove('product-info-tabs__button--active');
          btn.setAttribute('aria-selected', 'false');
        });
        
        tabContents.forEach(function(content) {
          content.classList.remove('product-info-tabs__content--active');
        });
        
        this.classList.add('product-info-tabs__button--active');
        this.setAttribute('aria-selected', 'true');
        
        const targetContent = container.querySelector('#tab-' + targetTab);
        if (targetContent) {
          targetContent.classList.add('product-info-tabs__content--active');
        }
        
        // Scroll the clicked tab into view (horizontally centered)
        this.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        
        // Update scroll state after scrolling
        setTimeout(function() {
          if (nav) updateScrollState(nav);
        }, 300);
      });
    });
  }
});
  
// Helper function to update scroll state for gradient indicators
function updateScrollState(nav) {
  const scrollLeft = nav.scrollLeft;
  const scrollWidth = nav.scrollWidth;
  const clientWidth = nav.clientWidth;
  const scrollEnd = scrollWidth - clientWidth;
  
  // Threshold for when to consider "at the edge" (5px tolerance)
  const threshold = 5;
  
  // At the start?
  if (scrollLeft <= threshold) {
    nav.classList.remove('scrolled-start');
  } else {
    nav.classList.add('scrolled-start');
  }
  
  // At the end?
  if (scrollLeft >= scrollEnd - threshold) {
    nav.classList.add('scrolled-end');
  } else {
    nav.classList.remove('scrolled-end');
  }
}